import React, { useState, useEffect } from "react";
import logo from './careiologo.png';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import LandingPage from './components/LandingPage';
import AppointmentStep1 from './components/appointment/Step1';
import AppointmentList from './components/appointment/List';
import ImagingStudyList from './components/imagingstudy/List';
import ReportsList from './components/diagnosticreport/List';
//import authentication from "react-azure-b2c";
//import jwt_decode from "jwt-decode";
import Dashboard from './components/Dashboard';
import GuestLink from './components/sharelink/GuestLink';
import Organizations from './components/Organizations';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import PatientDataAccess from './components/common/access';
import PatientSupport from "./components/common/support";
import GoogleTranslate from "./GoogleTranslate";
import ShareCode from "./components/sharelink/Share"; 
import UploadShareCode from "./components/sharelink/Upload"; 

export const msalInstance = new PublicClientApplication(loginRequest);

function Home() {
    let AccessToken = localStorage.getItem("AccessToken");
    let UserName = localStorage.getItem("UserName");

    useEffect(() => {
        console.log("1")
    })
    const { instance } = useMsal();
    const { accounts } = useMsal();
    console.log(accounts)

    function signOutClickHandler(instance) {
        const logoutRequest = {
            account: instance.logoutRedirect()
        };
        instance.logoutPopup(logoutRequest);
        localStorage.removeItem("AccessToken")
        localStorage.removeItem("AccessTokenInbox")
    }

    let showitemloggedin = localStorage.getItem("AccessToken") == null ? "d-none" : "";
    let hidesignin = localStorage.getItem("AccessToken") == null ? "show-signin" : "hide-signin";

    return (
        <>
            <UnauthenticatedTemplate>
                <header>
                    <nav className="navbar navbar-expand-lg navbar-light p-0">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="/"><img src={logo} className="App-logo" alt="logo" /></a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav">
                                <li className={`nav-item me-2 ${ hidesignin }`}>
                                <a className="nav-link" aria-current="page" href="/"><i className='fa fa-home home-icn'></i>&nbsp; Home</a>
                                </li>
                                <li className={`nav-item me-2 ${ showitemloggedin }`}>
                                <a className="nav-link" aria-current="page" href="/imagingstudy">Imaging Studies</a>
                                </li>
                                {/* <li className={`nav-item me-2 ${ showitemloggedin }`}>
                                <a className="nav-link" aria-current="page" href="/diagnosticreport">Diagnostic Reports</a>
                                </li> */}
                            </ul>
                            </div>
                            <GoogleTranslate />
                            <div className={`profilesec nonloggedbtn float-right p-0 ${ hidesignin }`}>
                                <button className='btn btn-primary disabled' onClick={() => instance.loginRedirect(loginRequest)}>
                                    Sign in
                                </button>
                                <span className="signin-infobox">Sign in to view your health records</span>
                                <span className="mr-4"><i className="fa fa-user-circle me-2"></i>{UserName}</span>
                                <a className="logout" onClick={() => signOutClickHandler(instance)} href="javacript:void(0)"><i className="fa fa-power-off"></i></a>
                            </div>
                            
                        </div>
                    </nav>
                </header>  
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <header>
                    {/* <a href='javacript:void(0)' onClick={Signout}>Signout</a> */}
                    <nav className="navbar navbar-expand-lg navbar-light p-0">
                    <div className="container-fluid">
                        <a className="navbar-brand" href="/home"><img src={logo} className="App-logo" alt="logo" /></a>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item me-2">
                            <a className="nav-link" aria-current="page" href="/"><i className='fa fa-home home-icn'></i></a>
                            </li>
                            {/* <li className="nav-item me-2">
                            <a className="nav-link" aria-current="page" href="/dashboard">Dashboard</a>
                            </li> */}
                            <li className="nav-item me-2">
                            <a className="nav-link" aria-current="page" href="/imagingstudy">Imaging Studies</a>
                            </li>
                            <li className="nav-item me-2">
                            <a className="nav-link" href="/diagnosticreport">Diagnostic Reports</a>
                            </li>
                            {/* <li className="nav-item me-2">
                            <a className="nav-link" href="/appointment">Appointments</a>
                            </li> */}
                        </ul>
                        </div>
                        <GoogleTranslate />
                        <div className="profilesec">
                            <span className="mr-4"><i className="fa fa-user-circle me-2"></i>{accounts[0]?.name}</span>
                            <a className="logout" onClick={() => signOutClickHandler(instance)} href="javacript:void(0)"><i className="fa fa-power-off"></i></a>
                        </div>
                    </div>
                    </nav>
                    
                </header>
            </AuthenticatedTemplate>

            <Router>
                <Routes>
                    <Route exact path="/home" element={<LandingPage />} />
                    <Route exact path="/appointment/Create" element={<AppointmentStep1 />} />
                    <Route exact path="/imagingStudy" element={<ImagingStudyList />} />
                    <Route exact path="/share" element={<ShareCode />} />
                    <Route exact path="/upload" element={<UploadShareCode />} />
                </Routes>
            </Router>

            <AuthenticatedTemplate>
                <Router>
                    <Routes>
                    {/* <Route exact path="/" element={<Organizations />} /> */}
                    <Route exact path="/" element={<LandingPage />} />
                    <Route exact path="/dashboard" element={<Dashboard />} />
                    <Route exact path="/appointment" element={<AppointmentList />} />
                    <Route exact path="/diagnosticreport" element={<ReportsList />} />
                    {/* <Route exact path="/Appointment/Step2" element={<AppointmentStep2 />} /> */}
                    </Routes>
                </Router>
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <Router>
                    <Routes>
                        <Route exact path="/organizations" element={<Organizations />} />
                        <Route exact path="/link" element={<GuestLink />} />
                        {/* <Route exact path="/share" element={<SharePage />} /> */}
                        <Route exact path="/" element={<LandingPage />} />
                        <Route exact path="/find" element={<PatientDataAccess />} />
                        <Route exact path="/support" element={<PatientSupport />} />
                    </Routes>
                </Router>
            </UnauthenticatedTemplate>
        </>
    )
}

export default Home;